import { render, staticRenderFns } from "./DialogEditStudent.vue?vue&type=template&id=7d1c90ec&"
import script from "./DialogEditStudent.vue?vue&type=script&lang=js&"
export * from "./DialogEditStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports